import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { selectBuckets, selectCurrentDate, selectSpreadsheetID, setBucketList } from './slice/buckets';
import { addBucketToSpreadsheet, getSpreadsheetData } from './slice/functions'
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { CATEGORIES, NAV_BACKGROUND_COLOR } from './constants';



export const AddBucket = ({ parentLucket }) => {

  const buckets = useSelector(selectBuckets);
  const [newBucketName, setNewBucketName] = useState("");
  const [newBucketOrder, setNewBucketOrder] = useState("");
  const [newBucketCategory, setNewBucketCategory] = useState("");
  const currentDate = useSelector(selectCurrentDate)
  const [missingInfoName, setMissingInfoName] = useState(false);
  const [missingInfoOrder, setMissingInfoOrder] = useState(false);
  const [missingInfoCategory, setMissingInfoCategory] = useState(false);
  const [addSuccess, setAddSuccess] = useState(false);

  const dispatch = useDispatch()

  async function addBucket() {
    if (newBucketName === "") {
      setMissingInfoName(true)
      setAddSuccess(false)
      return
    }

    setMissingInfoName(false)
    setMissingInfoOrder(false)
    setMissingInfoCategory(false)

    setAddSuccess(true)
    console.log('[Issue 1] AddBucket - Sending bucket data:', { newBucketName, newBucketOrder, newBucketCategory, currentDate });
    const result = await addBucketToSpreadsheet(newBucketName, newBucketOrder, newBucketCategory, parentLucket, currentDate)

    console.log('[Issue 1] AddBucket - API response received:', result);
    console.log('[Issue 1] AddBucket - Response data:', result.data);
    console.log('[Issue 1] AddBucket - Response data count:', result.data?.length);

    if (result.data && result.data.length > 0) {
      // Update Redux state with new bucket list
      dispatch(setBucketList(result.data));
      console.log('[Issue 1] AddBucket - Redux state updated with:', result.data);

      // If added offline, dispatch notification
      if (result.offline) {
        window.dispatchEvent(new CustomEvent('app-offline-mode', {
          detail: { message: '⚠️ Bucket added offline - will sync when back online' }
        }));
      }
    }
  }


  return (
    <Box
      sx={{
        backgroundColor: NAV_BACKGROUND_COLOR,
        padding: '24px',
        borderRadius: '12px',
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        maxWidth: '1200px',
        margin: '0 auto'
      }}
      component="form"
      autoComplete="off"
    >
      <div style={{ display: "flex", "flexDirection": "column" }}>
        <h2 style={{ marginBottom: '16px', color: '#333', fontSize: '24px' }}>Add New Bucket</h2>
        <TextField
          required
          error={missingInfoName}
          label="Bucket Name"
          placeholder="Enter bucket name..."
          variant="outlined"
          id='newlucketName'
          onChange={(e) => { setNewBucketName(e.target.value) }}
          sx={{
            flex: '1 1 300px',
            minWidth: '200px',
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: '#fafafa',
              },
            },
          }}
        />

        <div style={{
          display: 'flex',
          gap: '20px',
          alignItems: 'flex-start',
          flexWrap: 'wrap'
        }}>

          <FormControl
            variant="outlined"
            error={missingInfoCategory}
            sx={{
              flex: '1 1 300px',
              minWidth: '200px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: '#fafafa',
                },
              },
            }}
          >
            <Select
              labelId="newlucketCategory-label"
              id="newlucketCategory"
              value={newBucketCategory}
              onChange={(e) => { setNewBucketCategory(e.target.value) }}
              displayEmpty
            >
              <MenuItem value="">
                <em>Default: Category A</em>
              </MenuItem>
              {CATEGORIES.map((category, index) => (
                <MenuItem key={index} value={category}>
                  {category}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            error={missingInfoOrder}
            label="Order (Optional)"
            placeholder="default: at end"
            variant="outlined"
            id='newlucketOrder'
            type="number"
            onChange={(e) => { setNewBucketOrder(e.target.value) }}
            sx={{
              flex: '0 1 200px',
              minWidth: '180px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: '#fafafa',
                },
              },
            }}
          />

          <Button
            variant='contained'
            onClick={addBucket}
            sx={{
              flex: '0 1 auto',
              minWidth: '140px',
              height: '56px',
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: '8px',
              backgroundColor: '#667eea',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              boxShadow: '0 4px 8px rgba(102, 126, 234, 0.3)',
              transition: 'all 0.3s ease',
              '&:hover': {
                background: 'linear-gradient(135deg, #5568d3 0%, #653a8a 100%)',
                boxShadow: '0 6px 12px rgba(102, 126, 234, 0.4)',
                transform: 'translateY(-2px)',
              },
              '&:active': {
                transform: 'translateY(0px)',
              },
            }}
          >
            Add Bucket
          </Button>
        </div>

      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '16px',
        minHeight: '30px'
      }}>
        {addSuccess && (
          <p className='formSuccessAddBucket' style={{
            margin: '8px 0',
            padding: '8px 16px',
            backgroundColor: '#d1fae5',
            color: '#065f46',
            borderRadius: '6px',
            fontWeight: 500,
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span>✓</span> Bucket added successfully
          </p>
        )}
        {missingInfoName && (
          <div style={{
            backgroundColor: '#fee2e2',
            padding: '12px 16px',
            borderRadius: '6px',
            borderLeft: '4px solid #dc2626',
            marginTop: '8px'
          }}>
            <p className='formErrorAddBucket' style={{
              margin: '4px 0',
              color: '#dc2626',
              fontSize: '14px',
              fontWeight: 500
            }}>
              ⚠️ Missing Bucket Name
            </p>
          </div>
        )}
      </div>
    </Box >
  )
}